export enum FoljaMenyra {
  Deftore = 10,
  Habitore = 11,
  Lidhore = 12,
  LidhoreHabitore = 13,
  Kushtore = 14,
  Deshirore = 15,
  Urdherore = 16,
  Pashtjelluar = 17,
  FormaMeSC = 18
}

export enum FoljaForma {
  Veprore = 10,
  JoVeprore = 11,
}

export enum FoljaFormaFjales {
  cc = 10,
  s = 11
}

export enum FoljaKoha {
  ETashme = 10,
  EKryer = 11,
  EPakryer = 12,
  MeSeEKryer = 13,
  EKryerEThjeshte = 14,
  EKryerETejshkuar = 15,
  EArdhme = 16,
  EArdhmeESeShkuares = 17,
  EArdhmeII = 18,
  EArdhmeESeShkuaresII = 19,
  EArdhmeEPerparme = 20,
  EArdhmeEPerparmeESeShkuares = 21,
  EKryerEMbiperbere = 22,
  MeSeEKryerEMbiperbere = 23,
  ETashmeII = 24,
}

export enum FoljaZgjedhimi {
  I = 10,
  II = 11,
  III = 12,
  PaRregullt = 13,
}

export enum FoljaLlojiTemes {
  MeTemeO = 10, //Me temë - o
  MeTemeE = 11, //Me temë - e
  MeTemeUA = 12, //Me temë - ua
  MeTemeYE = 13, //Me temë - ye
  KanTeNjejtenTeme = 14, //Kan të njëjtën temë
  ZgjerimTemeMT = 15, //Zgjerim teme m -t
  ZgjerimTemeMJT = 16, //Zgjerim teme m -jt
  MeTemeUAdheZgjerimTemeMeJT = 17, //Me temë -ua dhe zgjerim teme me -jt
  ZgjerimTemeMR = 18, //Zgjerim teme m -r
  FoljeMeDysoreNeDisaFormaTS = 19, //Folje me dysorë në disa forma t/s
  MeTemeJE1 = 20, //Me temë - je 1
  MeTemeJE2 = 21, //Me temë - je 2
  MeTemeJE3 = 22, //Me temë - je 3
  MeTemeA1 = 23, //Me temë - a 1
  MeTemeA2 = 24, //Me temë - a 2
  FoljetMeTemeTeZgjeruarTeTipitPerkas = 25, //Foljet me temë të zgjeruar të tipit përkas
  FoljetShkasVrasNgasDheGergas = 26, //Foljet shkas, vras, ngas dhe gërgas
  NeTeKryerenEThjeshteNjejesMeTemeTeZgjeruarMeR = 27, //Në të kryerën e thjeshtë, njëjës, me temë të zgjeruar me -r-
  NeTeKryerenEThjeshteDheNePjesoreEZgjerojneTemenMePrapashtesenT = 28, //Në të kryerën e thjeshtë dhe në pjesore e zgjerojnë temën me prapashtesën -t-
  FoljaPi = 29, //Folja pi
  FoljaShtie = 30, //Folja shtie
  Supletive = 31, //Supletive
  Josupletive = 32, //Josupletive
  MasFoljeDysore1MeS = 33,//Mas (folje dysore 1 (me s))
  MatFoljeDysore2MeT = 34, //Mat (folje dysore 2 (me t))
}

export enum FoljaPeremri {
  Une = 10,
  Ti = 11,
  AiAjo = 12,
  Ne = 13,
  Ju = 14,
  AtaAto = 15,
}

export enum FoljaNumri {
  Njejes = 10,
  Shumes = 11,
}

export enum FoljaVeta {
  Epare = 10,
  Edyte = 11,
  Etrete = 12,
  // Njevetore = 13,
}

export enum FoljaUrdheroreTrajtaTeShkurtraTeRasesDhanore {
  DhanoreINjejes = 10,
  DhanoreIIINjejes = 11,
  DhanoreIShumes = 12,
  DhanoreIIIShumes = 13,
}

export enum FoljaUrdheroreTrajtaTeShkurtraTeRasesKallezore {
  KallezoreINjejes = 10,
  KallezoreIIINjejes = 11,
  KallezoreIShumes = 12,
  KallezoreIIIShumes = 13,
}

export enum FoljaUrdheroreTrajtaTeShkurtraTeBashkuara {
  DhanoreINjejesKallezoreIIINjejes = 10,
  DhanoreINjejesKallezoreIIIShumes = 11,
  DhanoreIShumesKallezoreIIINjejes = 12,
  DhanoreIShumesKallezoreIIIShumes = 13,
  DhanoreIIINjejesKallezoreIIINjejes = 14,
  DhanoreIIINjejesKallezoreIIIShumes = 15,
  DhanoreIIIShumesKallezoreIIINjejes = 16,
  DhanoreIIIShumesKallezoreIIIShumes = 17,
}

export enum FoljaFormaPashtjelluar {
  Pjesore = 10,
  Percjellore = 11,
  PaskajoreI = 12,
  PaskajoreII = 13,
  PaskajoreIII = 14,
  PaskajoreGege = 15,
  Mohore = 16,
}
